/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modality_WeightsInputs */

const en_us2_modality_weights = /** @type {(inputs: Modality_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weights`)
};

const pt_br2_modality_weights = /** @type {(inputs: Modality_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musculação`)
};

const es_419_modality_weights = /** @type {(inputs: Modality_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesas`)
};

const pt_pt2_modality_weights = /** @type {(inputs: Modality_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musculação`)
};

const fr_fr2_modality_weights = /** @type {(inputs: Modality_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musculation`)
};

const de_de2_modality_weights = /** @type {(inputs: Modality_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krafttraining`)
};

const it_it2_modality_weights = /** @type {(inputs: Modality_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sala pesi`)
};

/**
* | output |
* | --- |
* | "Weights" |
*
* @param {Modality_WeightsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const modality_weights = /** @type {((inputs?: Modality_WeightsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modality_WeightsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_modality_weights(inputs)
	if (locale === "es-419") return es_419_modality_weights(inputs)
	if (locale === "pt-PT") return pt_pt2_modality_weights(inputs)
	if (locale === "fr-FR") return fr_fr2_modality_weights(inputs)
	if (locale === "de-DE") return de_de2_modality_weights(inputs)
	if (locale === "it-IT") return it_it2_modality_weights(inputs)
	return en_us2_modality_weights(inputs)
});
export { modality_weights as "modality.weights" }